import React, { useState } from "react";
import { FaPlus, FaSave, FaTimes } from "react-icons/fa";

const FloatingActionButton = ({ onSave, onCancel, loading }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="fixed bottom-20 right-6 flex flex-col items-end gap-3">
            {/* Botones desplegables */}
            <div className={`flex flex-col items-end gap-3 transition-all duration-300 ${isOpen ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}>
                <button
                    className="w-14 h-14 bg-red-500 text-white rounded-full flex items-center justify-center shadow-lg transition-transform transform hover:scale-105"
                    onClick={onCancel}
                >
                    <FaTimes size={20} />
                </button>
                <button
                    className="w-14 h-14 bg-blue-500 text-white rounded-full flex items-center justify-center shadow-lg transition-transform transform hover:scale-105"
                    onClick={onSave}
                    disabled={loading}
                >
                    {loading ? (
                        <span className="animate-spin h-5 w-5 border-4 border-white border-t-transparent rounded-full"></span>
                    ) : (
                        <FaSave size={20} />
                    )}
                </button>
            </div>

            {/* Botón principal para abrir/cerrar */}
            <button
                className="w-16 h-16 bg-gray-800 text-white rounded-full flex items-center justify-center shadow-xl transition-transform transform hover:scale-110"
                onClick={() => setIsOpen(!isOpen)}
            >
                <FaPlus size={24} className={`transition-transform transform ${isOpen ? "rotate-45" : "rotate-0"}`} />
            </button>
        </div>
    );
};

export default FloatingActionButton;
